import React from 'react';

/**
 * Reusable search bar with clear button.
 *
 * Props:
 *   value       – current search string
 *   onChange     – called with new value on input change
 *   onClear     – called when ✕ is clicked (defaults to onChange(''))
 *   placeholder – input placeholder text
 *   className   – extra class on the wrapper
 */
export default function SearchBar({
  value,
  onChange,
  onClear,
  placeholder = 'Search...',
  className = '',
}) {
  const wrapperClass = ['search-wrapper', className].filter(Boolean).join(' ');

  function handleClear() {
    if (onClear) {
      onClear();
    } else {
      onChange('');
    }
  }

  return (
    <div className={wrapperClass}>
      <input
        className="search-input"
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {value && (
        <button
          className="search-clear"
          onClick={handleClear}
          title="Clear search"
        >
          ✕
        </button>
      )}
    </div>
  );
}
